<template>
  <div class="select" :class="{ 'disabled': disabled }" >
    <select v-model="selectedOption" :name="name" :id="id" :autofocus="autofocus">
      <option v-for="option in options" :key="String(option.value)" :value="String(option.value)">{{ option.name }}</option>
    </select>
    <span class="icon mdi mdi-chevron-down"></span>
  </div>
</template>

<script>

export default {
  name: 'Select',
  props: {
    name: String,
    id: String,
    options: Array,
    selected: String,
    autofocus: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedOption(value) {
      this.$emit('update', value);
    },
    selected(newVal) {
      // Keep internal model in sync with parent changes
      this.selectedOption = newVal != null ? String(newVal) : newVal;
    }
  },
  data() {
    return {
      selectedOption: this.selected != null ? String(this.selected) : this.selected
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .select {
    width: 100%;
    height: 35px;
    position: relative;
    font-size: 12px;
    text-align: left;
    cursor: pointer;

    &.disabled {
      opacity: .5;
      pointer-events: none;
    }

    select {
      width: 100%;
      height: 100%;
      position: relative;
      border: none;
      outline: none;
      color: $general-black-light;
      -webkit-appearance: none;
      padding: 0 40px 0 10px;
      border: solid 1px hsl(255, 0%, 85%);
      border-radius: 3px;

      &:focus { 
        outline: none !important;
        border-color: $brand-primary;
      }
    }

    .icon {
      width: 40px;
      height: 100%;
      font-size: 20px;
      right: 0;
      top: 0;
      position: absolute;
      pointer-events: none;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      opacity: .8;
    }

    .copy {
      width: auto;
      position: relative;
      font-size: 12px;
      font-weight: 700;
      padding: 0 5px;
    }
  }
</style>
